( function($) {

	var buttons = $( '.talentfunl-taxonomies-widget__nav button' ),
		tabs 	= $( '.talentfunl-taxonomies-widget__tab' );

	var hide_all_tabs = function() {
		buttons.removeClass( 'active' );
		tabs.hide();
	};

	var show_last_open_tab = function() {
		var btn = buttons.filter( '.last-active' );

		if ( btn ) {
			var taxonomy = btn.data( 'open' ),
				tab 	 = $( '#' + taxonomy );

			btn.addClass( 'active' );
			tab.show();
		}
	};

	// mark active button as last-active at start
	buttons.filter( '.active' ).addClass( 'last-active' );

	if ( $( document ).width() < 768 ) {
		// deactivate all buttons on mobile
		buttons.removeClass( 'active' );
		// hide all tabs
		$( '.talentfunl-taxonomies-widget__tab' ).hide();
	}

	$( window ).on( 'resize', function() {
		if ( $( document ).width() >= 768 ) {
			show_last_open_tab();
		} else {
			hide_all_tabs();
		}
	} );

	buttons.on( 'click', function() {
		var taxonomy = $( this ).data( 'open' ),
			tab = $( '#' + taxonomy ),
			btn = $( this );
		if( $( document ).width() < 768 && btn.hasClass( 'active' ) ) {
			btn.removeClass( 'active' );
			tab.hide();
		} else {
			buttons.removeClass( 'last-active' );
			btn.addClass( 'active last-active' ).siblings().removeClass( 'active' );
			tab.show().siblings().hide();
		}
	} );

	var refererPopup = {
		init: function() {
			$( 'a[href^="#popup-"]' ).magnificPopup( {
				type: 'inline',
				mainClass: 'mfp-fade'
			} );

			$( '#referer-name' ).on( 'keyup', function( e ) {

				var input = $( this ),
						value = input.val(),
						link = $( '.referal-link' ),
						tag = refererPopup.generate_tag( value ),
						template = link.data( 'link-pattern' ),
						url = template.replace( "\%referer\%", tag );

				link.html( url ).attr( 'href', url );
			} );

			$( document ).on( 'click', '.referal-link', function( e ) {
				e.preventDefault();

				var element = $( this )[0],
						range = document.createRange();

				range.selectNodeContents( element );

				var selection = window.getSelection();

				selection.removeAllRanges();
				selection.addRange( range );
				document.execCommand('copy');

				alert( popup_i18n.copied_to_clipboard );
			} );
		},

		generate_tag: function( value ) {
			value = value.replace( /[^a-z0-9\s\-]/gi, '' ).replace( /[\s\-]+/g, '-' ).toLowerCase();

			return value;
		}
	};

	refererPopup.init();

} )( jQuery );
